export default __webpack_public_path__ + "static/media/Black Dragon Tooth.9abfc468.jpg";